@if (GeneratedTypePredicates.isTeamTrainingSession(session)) {
	<sim-team-training-session-card
		[session]="session"
		[creationMode]="creationMode"
		[showRecordingExports]="showRecordingExports"
		[event]="event"
		[hideDraftSessions]="hideDraftSessions"
		[showOnlyRecordedScenarios]="showOnlyRecordedScenarios"
		[showLoadingSpinnerOnScheduledSession]="showLoadingSpinnerOnScheduledSession"
		[usedWithinEventSelection]="usedWithinEventSelection"
		[showRemoveAction]="showRemoveAction"
		[showEditAction]="showEditAction"
		[showJoinStartActions]="showJoinStartActions"
		[finishedRunsClickable]="finishedRunsClickable"
		[sessionStartable]="sessionStartable"
		(finishedRunClickedEmitter)="finishedRunClickedEmitter.emit($event)"
		(edit)="edit.emit($event)"
		(delete)="delete.emit($event)"
	>
		<ng-container actions>
			<ng-container *ngTemplateOutlet="actionsTemplate" />
		</ng-container>
	</sim-team-training-session-card>
} @else if (GeneratedTypePredicates.isNonSimulationSession(session)) {
	<sim-non-simulation-session-card
		[session]="session"
		(edit)="edit.emit($event)"
		(delete)="delete.emit($event)"
		[showRemoveAction]="showRemoveAction"
		[showEditAction]="showEditAction"
		[usedWithinEventSelection]="usedWithinEventSelection"
	>
		<ng-container actions>
			<ng-container *ngTemplateOutlet="actionsTemplate" />
		</ng-container>
	</sim-non-simulation-session-card>
} @else if (GeneratedTypePredicates.isExamSession(session)) {
	<sim-exam-session-card
		[session]="session"
		[event]="event"
		[isArchiveView]="isArchive"
		[isExamSchedule]="isExamSchedule"
		[showActionMenu]="showActionMenu"
		[disableControls]="creationMode"
		(onEdit)="edit.emit($event)"
		(onDelete)="delete.emit($event)"
	>
		<ng-container actions>
			<ng-container *ngTemplateOutlet="actionsTemplate" />
		</ng-container>
	</sim-exam-session-card>
} @else if (GeneratedTypePredicates.isPeerPracticeSession(session)) {
	<sim-peer-practice-session-card
		[session]="session"
		[event]="event"
		[showActionMenu]="showActionMenu"
		(onEdit)="edit.emit($event)"
		(onDelete)="delete.emit($event)"
	>
		<ng-container actions>
			<ng-container *ngTemplateOutlet="actionsTemplate" />
		</ng-container>
	</sim-peer-practice-session-card>
} @else if (GeneratedTypePredicates.isMultiRoomRecordingSession(session)) {
	<sim-multi-room-recording-session-card
		[session]="session"
		[event]="event"
		[showActionMenu]="showActionMenu"
		[disableControls]="creationMode"
		(onEdit)="edit.emit($event)"
		(onDelete)="delete.emit($event)"
	>
		<ng-container actions>
			<ng-container *ngTemplateOutlet="actionsTemplate" />
		</ng-container>
	</sim-multi-room-recording-session-card>
} @else if (GeneratedTypePredicates.isAutomaticRecordingSession(session)) {
	<sim-automatic-recording-session-card
		[session]="session"
		[event]="event"
		[showActionMenu]="showActionMenu"
		(onEdit)="edit.emit($event)"
		(onDelete)="delete.emit($event)"
	>
		<ng-container actions>
			<ng-container *ngTemplateOutlet="actionsTemplate" />
		</ng-container>
	</sim-automatic-recording-session-card>
} @else {
	<p>Unknown session type</p>
	<ng-container actions>
		<ng-container *ngTemplateOutlet="actionsTemplate" />
	</ng-container>
}

<!--Transclusion needs to be forwarded via template, because it can only be resolved once-->
<ng-template #actionsTemplate>
	<ng-content select="[actions]" />
</ng-template>
